module.exports = __webpack_public_path__ + "static/img/seki.50c45b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/seki.png
// module id = ChB1
// module chunks = 0